import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import Header from "../components/header/header";
import './mobileSwitch.css'

export const PublicRoute = () => {
  const { user } = useAuth();

  if (user) {
    return <Navigate to="/dashboard/start" />;
  }

  return (

      <Outlet className="example" />

  )
};